module.exports = __webpack_public_path__ + "img/mbank-ludzie-rgb.3fa6cb64.png";